<template>
    <div class="center-feed">
        <ion-grid>
            <ion-row v-if="compareTune === null">
                <ion-col v-if="!group && friendUser === null && exclUnrated === false && musician === null" size="3">
                    <ion-fab vertical="top" horizontal="start">
                        <ion-fab-button @click="createTune()">
                            <ion-icon :icon="add"></ion-icon>
                        </ion-fab-button>
                    </ion-fab>
                </ion-col>
                <ion-col size="9">
                    <ion-searchbar v-bind:placeholder="$t('searchBy')" :debounce="1000" show-clear-button="always" :clear-icon="trashBin" @ionInput="searchTitle($event)"></ion-searchbar>
                </ion-col>
            </ion-row>
            <ion-row v-if="exclUnrated === false && compareTune === null && group === null && friendUser === null" class="whiterow">
                <ion-col size="6">
                    <ion-item lines="none">
                        <ion-label>{{ $t('filterRated') }}</ion-label>
                        <ion-toggle v-model="filterRatedTunesCheckbox" v-on:ionChange="filterRatedTunesSelected()"></ion-toggle>
                    </ion-item>
                </ion-col>
                <ion-col size="6">
                    <ion-item lines="none">
                        <ion-label>{{ $t('filterUnverified') }}</ion-label>
                        <ion-toggle v-model="filterUnverifiedCheckbox" v-on:ionChange="filterUnverifiedSelected()"></ion-toggle>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>

        <div v-if="userTunes">
            <div v-for="(tune) in userTunes" v-bind:key="tune.tune_id" @click="linkroute(tune.tune_id)" class="user-tune-card">
                <div class="tune-card-header">
                    <h4 style="margin: 0; padding: 0;">{{tune.title}}</h4>
                    <div v-if="group!=null" class="group-toggle-row">
                        <p style="margin: 0; padding: 0;">Group: </p>
                        <ion-toggle v-model="tune.group_tune" v-bind:disabled="!groupAdmin" v-on:ionChange="markGroupTune(tune.tune_id, $event)" @click="stopProp($event)">
                        </ion-toggle>
                    </div>
                </div>
                <div v-if="tune.firstbars" class="firstbars-wrapper">
                    <AbcScore
                        v-bind:abcCode="tune.firstbars"
                        v-bind:abcCodeId="tune.tune_id"
                    />
                </div>
                <div class="ratings-row">
                    <div class="rating-group">
                        <p style="margin: 0; padding: 0;">Star: </p>
                        <star-rating
                            :star-size=30
                            :show-rating="false"
                            :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                            :max-rating=3
                            :border-width=0
                            active-color="#ffc800"
                            v-model:rating="tune.level"
                            @update:rating="setLevelRating(tune)"
                        />
                    </div>
                    <div class="rating-group">
                        <p style="margin: 0; padding: 0;">Heart: </p>
                        <heart-rating
                            :heart-size=30
                            :show-rating="false"
                            :increment=0.5
                            :border-width=0
                            v-model:rating="tune.rating"
                            @update:rating="setLevelRating(tune)"
                        />
                    </div>
                </div>
            </div>
        </div>

        <ion-infinite-scroll @ionInfinite="ionInfinite($event)">
            <ion-infinite-scroll-content loadingText="Please wait..." loadingSpinner="bubbles">
            </ion-infinite-scroll-content>
        </ion-infinite-scroll>
    </div>
</template>

<style scoped>
.user-tune-card {
    background-color: var(--ion-color-light);
    border-radius: 10px;
    margin: 10px;
    padding: 10px;
}

.tune-card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.group-toggle-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
}

.firstbars-wrapper {
    max-width: 100%;
    overflow-x: auto;
}

.ratings-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
}

.rating-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.rating-group p {
    display: none;
}

@media (min-width: 768px) {
    .rating-group p {
        display: block;
    }
}
</style>

<script>
    import { IonFab,IonFabButton,IonToggle,IonLabel,IonIcon,IonSearchbar,/*IonContent, IonHeader, IonPage, IonTitle, IonToolbar ,*/IonList,IonItem,/*IonButton,*/ IonGrid, IonRow, IonCol,IonInfiniteScroll,IonInfiniteScrollContent/*, IonSelect, IonSelectOption*/} from '@ionic/vue';
    import { add, /*search,*/ trashBin } from 'ionicons/icons';
    import UserTuneDataService from "../services/UserTuneDataService";
    import RatingDataService from "../services/RatingDataService";
    import MgroupTuneDataService from "../services/MgroupTuneDataService";
    import StarRating from 'vue-star-rating';
    import HeartRating from 'vue-heart-rating';
    import AbcScore from "./AbcScore.vue";//Added 220126

    export default {
        name: "userTunes-list",
        components: {
            IonFab,
            IonFabButton,
            IonToggle,
            IonLabel,
            IonInfiniteScroll,
            IonInfiniteScrollContent,
            IonIcon,
            IonList,
            IonItem,
            IonGrid,
            IonRow,
            IonCol,
            IonSearchbar,
            StarRating,
            HeartRating,
            AbcScore
        },
        setup() {
            return {
                add,
                /*search,*/
                trashBin
            }
        },
        //exclUnrated changes LEFT JOIN on user_tunes to JOIN, friendUser adds a JOIN to another user_tunes with id=friendUser
        props: {exclUnrated: {default: false},
                friendUser: {default: null},
                compareTune: {default: null},
                disableInfiniteScroll: {default: false},
                group: {default: null},
                groupAdmin: {default: false},
                musician: {default: null},
                toLearn: {default: false}
        },
        data() {
            return {
                userTunes: [],
                infiniteScrollDisabled: this.disableInfiniteScroll,
                title: null,
                filterRatedTunesCheckbox: false, //Added 2022-02-07 if true filter out the users rated tunes
                filterUnverifiedCheckbox: false, //Added 2023-06-21 if true filter out tunes that are not unverified
                offset: 0, //Added 2022-12-31 for InfiniteScroll
            };
        },
        methods: {
            /*async*/ retrieveTunes(excludeUnrated,/*filter,*/friendUser,compareTune, filterRatedTunes, filterUnverified, group, groupAdmin,title, musician) {
                const data = 
                {
                    excludeUnrated: excludeUnrated,
                    //filter: filter,//JSON with 0-n filter variables
                    friendUser: friendUser,
                    compareTune: compareTune,
                    filterRatedTunes: filterRatedTunes,
                    filterUnverified: filterUnverified,
                    offset: this.offset,
                    group: group,
                    groupAdmin: groupAdmin,
                    title: title,
                    musician: musician,
                    toLearn: this.toLearn
                }

                UserTuneDataService.getAll(data)
                .then(response => {
                    this.userTunes = response.data;
                })
                .catch(e => {
                    console.log(e);
                });
            },
            linkroute(tuneId) {
                this.$router.push('/usertunes/' + tuneId);
            },
            //updates the userTunesList with a result set from a title search
            searchTitle(event) {
                this.offset = 0; //Added 2023-01-06 to cancel the offset if page has scrolled
                var title = event.target.value;
                this.title = title
                this.infiniteScrollDisabled = false; //Fullösning eftersom inte lyckats disable InfiniteScroll på riktigt
                if (/*this.*/title != "") {
                    this.retrieveTunes(this.exclUnrated,/*{},*/this.friendUser, this.compareTune, this.filterRatedTunesCheckbox, this.filterUnverifiedCheckbox /*filter rated tunes or unverified even if search from 2023-06-21*/, this.group, this.groupAdmin,title, this.musician);
                }
                else {
                    this.retrieveTunes(this.exclUnrated,/*{},*/this.friendUser, this.compareTune, this.filterRatedTunesCheckbox, this.filterUnverifiedCheckbox /*filter rated tunes or unverified even if search from 2023-06-21*/, this.group, this.groupAdmin,null, this.musician);
                }
            },

            //Called if checkbox filterRatedTunesCheckbox is clicked
            filterRatedTunesSelected() {
                this.offset = 0; //Added 2023-01-06 to cancel the offset if page has scrolled
                this.infiniteScrollDisabled = false; //Fullösning eftersom inte lyckats disable InfiniteScroll på riktigt
                this.retrieveTunes(this.exclUnrated,/*this.filter,*/this.friendUser, this.compareTune, this.filterRatedTunesCheckbox, this.filterUnverifiedCheckbox, this.group, this.groupAdmin,this.title, this.musician);
            },
            filterUnverifiedSelected() {
                this.offset = 0; //Added 2023-01-06 to cancel the offset if page has scrolled
                this.infiniteScrollDisabled = false; //Fullösning eftersom inte lyckats disable InfiniteScroll på riktigt
                this.retrieveTunes(this.exclUnrated,/*this.filter,*/this.friendUser, this.compareTune, this.filterRatedTunesCheckbox, this.filterUnverifiedCheckbox, this.group, this.groupAdmin,this.title, this.musician);
            },
            createTune() {
            this.$router.push('/add');
            },
            //Called whenever a user input a level or rating
            setLevelRating(tune/*, index*/) {
                event.stopPropagation();//The warning is probably false due to the fact that VSCode think this is ts. The line prevents reroute to tune if rating is clicked
                var data = {
                    rating: tune.rating,
                    level: tune.level,
                };
                RatingDataService.update(tune.tune_id, data)
                .catch(e => {
                    console.log(e);
                });
            },
            markGroupTune(tuneId, event) {
                event.stopPropagation();
                var data = {
                    tune_id: tuneId
                };
                MgroupTuneDataService.update(this.group, data)
                .catch(e => {
                    console.log(e);
                });
            },
            stopProp(event) {
                event.stopPropagation();
            },
            ionInfinite(event) {
                //console.log(event);
                if(!this.infiniteScrollDisabled) { //Fullösning eftersom inte lyckats disable InfiniteScroll på riktigt
                    this.offset += 1;
                    const data =
                    {
                        excludeUnrated: this.exclUnrated,
                        friendUser: this.friendUser,
                        compareTune: this.compareTune,
                        filterRatedTunes: this.filterRatedTunesCheckbox,
                        filterUnverified: this.filterUnverifiedCheckbox,
                        offset: this.offset,
                        group: this.group,
                        groupAdmin: this.groupAdmin,
                        title: this.title,
                        musician: this.musician,
                        toLearn: this.toLearn
                    }

                    UserTuneDataService.getAll(data)
                    .then(response => {
                        for (let x of response.data) {
                            this.userTunes.push(x);
                        }
                        event.target.complete();
                        if (response.data.length < 25) {
                            //event.enable(false);
                            this.infiniteScrollDisabled = true;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    });
                }
                else {
                    event.target.complete(); //Fullösning eftersom inte lyckats disable InfiniteScroll på riktigt
                }
            },
        },
        mounted() {
            this.retrieveTunes(this.exclUnrated,/*{},*/this.friendUser, this.compareTune, this.filterRatedTunesCheckbox, this.filterUnverifiedCheckbox, this.group, this.groupAdmin, null, this.musician);
        },
    };
</script>